import { BankAccountDTO, CustomerDTO } from "@smartx/mikro-vt-client-api"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import DataList, { IField } from "../../../components/DataList/DataList"
import { getAddress } from "../../../functions/getAddress"

interface IOverviewCustomerProps {
  customerData: CustomerDTO
}

const OverviewCustomer: React.FC<IOverviewCustomerProps> = ({
  customerData,
}) => {
  const { t } = useTranslation()

  const bankAccountFields: Array<IField> = []

  customerData?.bankAccounts.forEach(
    (bankAccount: BankAccountDTO, index: number) => {
      bankAccountFields.push(
        {
          label: t(`case.fields.foreignBank${index + 1}`),
          value: bankAccount.primaryBank,
          fieldType: "text",
        },
        {
          label: t(`case.fields.foreignBankAccount${index + 1}`),
          value: bankAccount.accountNumber,
          fieldType: "bankAccount",
        },
      )
    },
  )

  const fieldArr: Array<IField> = [
    {
      label: t("case.fields.symbolsId"),
      value: customerData.symbolsId,
      fieldType: "text",
    },
    {
      label: t("case.fields.companyName"),
      value: customerData.companyName,
      fieldType: "text",
    },
    {
      label: t("case.fields.companyOperationForm"),
      value: customerData.companyOperationForm,
      fieldType: "CVT",
      list: "MIKRO_OPERATION_FORM_LIST",
    },
    {
      label: t("case.fields.registrationNumber"),
      value: customerData.registrationNumber,
      fieldType: "text",
    },
    {
      label: t("case.fields.addressHeadQuarters"),
      value: getAddress(customerData.addresses, "HEADQUARTERS"),
      fieldType: "text",
    },
    {
      label: t("case.fields.addressMailing"),
      value: getAddress(customerData.addresses, "MAILING"),
      fieldType: "text",
    },
    {
      label: t("case.fields.taxNo"),
      value: customerData.taxNo,
      fieldType: "text",
    },
    {
      label: t("case.fields.contactName"),
      value: customerData.contactName,
      fieldType: "text",
    },
    {
      label: t("case.fields.contactPhone"),
      value: customerData.contactPhone,
      fieldType: "phone",
    },
    {
      label: t("case.fields.contactEmail"),
      value: customerData.contactEmail,
      fieldType: "text",
    },
    ...bankAccountFields,
    {
      label: t("case.fields.customer.makRegistrationNumber"),
      value: customerData.makRegistrationNumber,
      fieldType: "text",
    },
  ]

  useEffect(() => {}, [customerData])

  return <DataList dataList={fieldArr} />
}

export default OverviewCustomer
